import { PageShell } from '../components/Chrome';

export function PrivacyPage() {
  return (
    <PageShell>
      <article className="site-wrap page-head legal-page">
        <div className="overline">Privacy</div>
        <h1>How Byte-Size handles your information.</h1>
        <p className="hero-sub">Last updated 19 July 2026.</p>

        <h2>Information collected</h2>
        <p>When you submit an enquiry, Byte-Size collects the information you enter, such as your name, contact details, business name and description of the problem. The website may also record basic source information, including the page you arrived from and campaign tags in the link, so enquiries can be attributed to channels such as Meta advertisements, referrals or business cards.</p>

        <h2>Why it is used</h2>
        <p>The information is used to read and respond to your enquiry, understand what help may be appropriate, keep a record of the conversation and assess which outreach channels are working. It is not sold to advertisers.</p>

        <h2>Services involved</h2>
        <p>The website is hosted by Netlify. Enquiries are stored in a managed PostgreSQL database connected to the Byte-Size Netlify project. A copy may also be processed through Netlify Forms to notify Byte-Size, and a transactional email provider may be used to send an acknowledgement. When analytics or advertising measurement is enabled, Google Analytics and the Meta Pixel may receive standard website activity and campaign information.</p>

        <h2>Storage and access</h2>
        <p>Reasonable steps are taken to limit access to the information and protect the accounts used to store it. Information is kept only for as long as it remains reasonably useful for the enquiry, the resulting business relationship or normal record-keeping.</p>

        <h2>Your choices</h2>
        <p>Do not include passwords, payment card details, medical information or other highly sensitive information in the enquiry form. You can ask to access, correct or delete information associated with your enquiry by submitting a new request through the <a href="/start/">contact form</a> and mentioning that it is a privacy request.</p>

        <h2>Questions</h2>
        <p>Privacy questions can be sent through the <a href="/start/">Byte-Size enquiry form</a>.</p>
      </article>
    </PageShell>
  );
}
